<style scoped>
a.paginate_button.current {
  background: black !important;
}
input[type="search"] {
  border: 1.5px solid #d8dbe0;
  border-radius: 4px;
  padding: 5px;
}
</style>
<template>
  <CCard>
    <CCardHeader
      style="background:#1a3665;color:white"
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center"
    >
      Master Periode
      <template v-if="role_status && role_status.status_create">
      <CButton
        color="success"        
        class="btn-md ml-auto button-md-block px-3"
        @click="createData">Tambah</CButton>
      </template>
      <template v-else>
      <CButton
        color="secondary"        
        class="btn-md ml-auto button-md-block px-3"
        disabled>Tambah</CButton>
      </template>
    </CCardHeader>

    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/data-master/master-periode"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#ajuan"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >Periode Sertifikasi</router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/data-master/master-periode-rpl"
          class="nav-link p-3 px-3 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          style="background-color:#486ba7"
          href="#Diterima"
          role="tab"
          aria-controls="home"
          aria-selected="false"
        >Periode RPL</router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/data-master/master-periode-iuran"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#Diterima"
          role="tab"
          aria-controls="home"
          aria-selected="false"
        >Periode Iuran</router-link>
      </li>
    </ul>

    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
            @keyup="cariData"
          />
          <br />
        </CCol>

        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>

            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>

            <template #statusPenerbitan="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon
                  icon="check"
                  class="text-success"
                  v-if="item.statusPenerbitan == 1"
                />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>

            <template #aksi="{item, index}">
              <td class="py-2 text-center">
                <template v-if="role_status && role_status.status_update">
                <CButton v-c-tooltip="'Ubah'" color="info" square size="sm" @click="updateData(item, index)">
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Ubah'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Hapus'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <CCol sm="12 mb-2">
              <label for class="font-weight-bold">Tahun</label>
              <br />
              <multiselect
                class="mulit-select"
                label="labelPeriode"
                placeholder="Pilih Tahun"
                :show-labels="false"
                required
                v-model="periode"
                @input="(value) => changePeriode(value)"
                :options="dataTahun"
                :class="{
                  'has-error': $v.periode.$error
                }"
              ></multiselect>
              <span class="text-danger" v-show="validation.tahun">*Tahun Harus Diisi</span>
            </CCol>
            <br />
            <CCol sm="12 mb-2">
              <label for class="font-weight-bold">Periode</label>
              <br />
              <multiselect
                class="mulit-select"
                placeholder="Pilih Periode"
                :show-labels="false"
                required
                label="labelValue"
                v-model="periodeNumber"
                @input="(value) => changePeriodeNumber(value)"
                :options="periodeOptions"
                :class="{
                  'has-error': $v.periodeNumber.$error
                }"
              ></multiselect>
              <span class="text-danger" v-show="validation.periode">*Periode Harus Diisi</span>
            </CCol>

            <CCol sm="12">
              <!-- statusPenerbitan -->
              <label for class="font-weight-bold">Status Aktif</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadioGrader"
                    value="1"
                    v-model="formData.status"
                    id="aktifGrader"
                    checked
                  />
                  <label class="custom-control-label" for="aktifGrader">Ya</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadioGrader"
                    value="0"
                    id="tidak_aktifGrader"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="tidak_aktifGrader">Tidak</label>
                </div>
              </div>
              <br />
              <div class="text-danger" v-if="$v.formData.status.$error">Status Harus Diisi</div>
            </CCol>

            <CCol sm="12">
              <label for class="font-weight-bold">Status Penerbitan</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadioPenerbitan"
                    value="1"
                    v-model="formData.statusPenerbitan"
                    id="aktifPenerbitan"
                  />
                  <label class="custom-control-label" for="aktifPenerbitan">Ya</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadioPenerbitan"
                    value="0"
                    id="tidak_aktifPenerbitan"
                    v-model="formData.statusPenerbitan"
                  />
                  <label class="custom-control-label" for="tidak_aktifPenerbitan">Tidak</label>
                </div>
              </div>
              <br />
              <div
                class="text-danger"
                v-if="$v.formData.statusPenerbitan.$error"
              >Status Penerbitan Harus Diisi</div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>
        </template>
        <template #footer>
          <CButton @click="closeModal" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
import { required } from "vuelidate/lib/validators";

import PeriodeRplService from "../../services/datamaster/periode-rpl.service";
import BaseUrl from "../../services/base-url";
import { AlertUtils } from "../../mixins/AlertUtils";

const fields = [
  { key: "no", _style: "width: 8%" },
  {
    key: "tahun",
    _style: "text-align: left;"
  },
  {
    key: "periode",
    _style: "text-align: left;"
  },
  {
    key: "status",
    label: "Status Periode Aktif",
    _style: "text-align: center;"
  },
  {
    key: "statusPenerbitan",
    label: "Status Penerbitan Aktif",
    _style: "text-align: center;"
  },
  { key: "aksi", _style: "width:15%; text-align: center" }
];

export default {
  name: "Periode",
  mixins: [AlertUtils],
  data() {
    return {
      validation: {
        tahun: false,
        periode: false,
        status: false
      },
      dataTahun: [],
      search: "",
      periode: "",
      dataPeriod: [],
      periodeOptions: [
        {
          labelValue: 1,
          value: 1
        },
        {
          labelValue: 2,
          value: 2
        },
        {
          labelValue: 3,
          value: 3
        },
        {
          labelValue: 4,
          value: 4
        },
        {
          labelValue: 5,
          value: 5
        }
      ],
      periodeNumber: "",
      items: [],
      actionPost: "",
      pageSize: "10",
      formData: {
        tahun: "",
        periode: "",
        status: "",
        statusPenerbitan: ""
      },
      pagination: {
        totalPages: 0
      },
      title: "",
      fields,
      fileName: "Pilih File",
      title: "",
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: [],
      timeout: null,
      awaitingSearch: false,
      role_status: null
    };
  },

  validations: {
    formData: {
      status: { required },
      statusPenerbitan: { required }
    },
    periode: { required },
    periodeNumber: { required }
  },

  mounted() {
    this.getTahun();
    this.getPeriod();
    this.baseUrl = BaseUrl();
    this.getData("0", this.pageSize, "default");
    this.roleData();
  },
  watch: {
    currentPage: function(val) {
      var page = val - 1;
      this.indexed = page * 10;
      this.getData(val - 1, this.pageSize, this.search);
    },
    myModal: function() {
      if (!this.myModal) {
        this.$v.$reset();
      }
    }
  },

  methods: {
    getPeriod() {
      for (let index = 1; index < 30; index++) {
        this.dataPeriod.push({
          labelPeriode: 0 + index,
          value: 0 + index
        });
      }
    },

    getTahun() {
      for (let index = 0; index < 40; index++) {
        this.dataTahun.push({
          labelPeriode : 2017+index,
          value : 2017+index
        })
      }
    },
    changePeriode(e) {
      // comment console console.log(e.value);
      if (e.value != null) {
        this.validation.tahun = false;
        this.formData.tahun = e.value;
      } else {
        this.formData.tahun = "";
      }
    },

    changePeriodeNumber(e) {
      // comment console console.log(e.value);
      if (e.value != null) {
        this.validation.periode = false;
        this.formData.periode = e.value;
      } else {
        this.formData.periode = "";
      }
    },

    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },

    cariData() {
      // clear timeout variable
      clearTimeout(this.timeout);
      var vm = this;
      this.timeout = setTimeout(function() {
        vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },

    pageChange() {
      this.getData(currentPage, this.pageSize, this.search);
    },

    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            PeriodeRplService.deletePeriode(this.formData)
              .then(response => {
                // comment console console.log(response);
                this.alertDeleteSuccess();
                // this.getData("1");
                this.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                this.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter) {
      // comment console console.log("this function");
      if (filter == "") {
        filter = "default";
      }
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      PeriodeRplService.getPeriode(currentPage, pageSize, filter)
        .then(response => {
          // comment console console.log(response.data);

          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;

          loader.hide();
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },

    putData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      PeriodeRplService.putPeriode(this.formData)
        .then(response => {
          vm.myModal = false;
          loader.hide();
          vm.alertEditSuccess();

          vm.getData("0", "10", "default");
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide();
          this.alertError();
          vm.alertError(error.response.data.message);
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {
        tahun: "",
        periode: "",
        status: "",
        statusPenerbitan: ""
      };
      this.periode = [];
      this.periodeNumber = [];
      this.fileName = "";
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
      this.title = "Edit";
      this.periode = [
        {
          labelTahun: item.tahun
        }
      ];
      this.periodeNumber = [
        {
          labelValue: item.periode
        }
      ];
    },

    postData() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        if (this.actionPost == "insert") {
          this.insertData(this.formData);
        } else if (this.actionPost == "update") {
          this.putData();
        }
      }
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log(formData);
      // comment console console.log("post");
      var vm = this;

      PeriodeRplService.postPeriode(formData)
        .then(response => {
          loader.hide();
          vm.myModal = false;
          vm.alertSuccess();
          vm.getData("0", this.pageSize, this.search);
        })
        .catch(error => {
          loader.hide();

          // comment console console.log(error);
          vm.alertError(error.response.data.message);
        });
    },

    closeModal() {
      this.myModal = false;
      this.validation.periode = false;
      this.validation.status = false;
      this.validation.tahun = false;
    },

    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === '/data-master/master-periode' );  
      this.role_status = data;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
